import React from 'react';
import { Grid, Skeleton } from '@mui/material';

const DateInfoSkeleton = () => {
  return (
    <Grid item xs={12} container direction="column">
      {/* Línea de fechas (In - Out) */}
      <Skeleton
        variant="text"
        width="80%"
        height={20} // similar al Typography fontSize 15–18
        sx={{ mb: 0.5 }}
      />

      {/* Línea de noches y huéspedes */}
      <Skeleton variant="text" width="60%" height={20} />
    </Grid>
  );
};

export default DateInfoSkeleton;
